import { api } from './axios';
import { authService } from './auth';

export interface Processo {
  id: number;
  nome_processo: string;
  setor_processo_fk: number;
  prioridade_baixa: number;
  prioridade_media: number;
  prioridade_alta: number;
  prioridade_urgente: number;
  created_at?: string;
  updated_at?: string;
  setor?: {
    id: number;
    nome_setor: string;
  };
}

class ProcessoService {
  /**
   * Listar todos os processos
   */
  async getAll(): Promise<Processo[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Processo[]>('/processos');
    return response.data;
  }

  /**
   * Obter processos por setor
   */
  async getBySetor(setorId: number): Promise<Processo[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Processo[]>(`/processos/setor/${setorId}`);
    return response.data;
  }

  /**
   * Obter processo por ID
   */
  async getById(processoId: number): Promise<Processo> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Processo>(`/processos/${processoId}`);
    return response.data;
  }

  /**
   * Obter histórico de versões de um processo
   */
  async getVersions(processoId: number): Promise<{ 
    versions: Processo[];
    acessos: Array<{
      id: number;
      processo_fk: number;
      usuario_fk: number;
      usuario?: {
        id: number;
        name: string;
        email: string;
        avatar?: string;
      };
      created_at: string;
      updated_at: string;
    }>;
    acessocount: number;
  }> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get(`/processos/${processoId}`);
    return response.data;
  }
}

export const processoService = new ProcessoService();